// @flow
import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown/with-html';

import Page, { Grid } from '@atlaskit/page';
import Button from '@atlaskit/button';
import Icon from '@atlaskit/icon';
import { ProgressIndicator } from '@atlaskit/progress-indicator';

import OctoIcon from '../components/assets/octoIcon';

import assets from '../assets/gettingStarted';

const Wrapper = styled.div`
    margin-top: 28px;
    > * {
        padding-left: 20%;
        padding-right: 20%;
    }
`;

const Head = styled.div`
    margin: 14px 0;
    > * {
        display: inline-block;
        vertical-align: middle;
    }

    > h1 {
        margin-top: 0;
    }
`;

const Body = styled.div`
    margin: 28px 0;
    h3 {
        margin-bottom: 28px;
    }
    > div {
        display: flex;
        justify-content: center;
        img {
            max-width: 90%;
        }
    }
    p {
        margin: 28px 0;
        white-space: pre-wrap;
    }
`;

const Footer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    .toggle {
        justify-content: center;
        margin: 0 28px;
        width: 115px;
    }
`;

const getBetween = (value, min, max) => Math.min(max, Math.max(min, value));

const GettingStarted = () => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(() => {
        assets.forEach((asset) => {
            // Not sure about the purpose of this code snippet.. maybe used to load images upfront in user's browser
            const img = document.createElement('img');
            img.src = asset.src;
            img.onload = () => {
                img.remove();
            };
            img.style.display = 'none';
            img.style.width = '0px';
            img.style.height = '0px';
            document.body.appendChild(img);
        });
    }, []);

    const onAssetChange = useCallback(
        (direction) => setSelectedIndex((prev) => getBetween(prev + direction, 0, assets.length - 1)),
        [],
    );

    const isLast = selectedIndex === assets.length - 1;
    const asset = assets[selectedIndex];
    return (
        <Page>
            <Grid layout="fluid">
                <Wrapper>
                    <Head>
                        <Icon glyph={OctoIcon} label="Octo icon" size="large" />
                        <h1>Get Started</h1>
                    </Head>

                    <Body>
                        <h3>{asset.title}</h3>
                        <ReactMarkdown source={asset.text} escapeHtml={false} />
                        <div>
                            <img alt={asset.title} src={asset.src} />
                        </div>
                    </Body>

                    <Footer>
                        <Button className="toggle" isDisabled={selectedIndex === 0} onClick={() => onAssetChange(-1)}>
                            Prev
                        </Button>
                        <ProgressIndicator selectedIndex={selectedIndex} values={assets.map((a, i) => i)} />
                        <Button
                            className="toggle"
                            appearance={isLast ? 'primary' : 'default'}
                            href=""
                            target="_top"
                            onClick={() => (isLast ? window.PlatformAdapter.navigateHomePage() : onAssetChange(1))}
                        >
                            {isLast ? 'Go to Octo' : 'Next'}
                        </Button>
                    </Footer>
                </Wrapper>
            </Grid>
        </Page>
    );
};
export default GettingStarted;
